import {
	Component,
	OnInit,
	OnChanges,
	Input,
	Output,
	EventEmitter,
	ElementRef,
} from "@angular/core";

@Component({
	selector: "app-option-text",
	templateUrl: "./option-text.directive.html",
	styleUrls: ["./option-text.directive.css"],
})
export class OptionTextDirective implements OnChanges {
	@Input() optionData: any;
	@Input() option_id?: string;

	@Input() checkBoxStyle?: string;
	@Input() fontSize?: string;
	@Input() fontColor?: string;
	@Input() vPadding?: string;
	@Input() showResult?: Boolean;
	@Input() inverted?: Boolean;
	@Input() textDirection: string;
	@Output() OptionSelected?: EventEmitter<any> = new EventEmitter<any>();

	private el: HTMLElement;
	public selected: Boolean = false;
	constructor(private elRef: ElementRef) {
		this.el = elRef.nativeElement;
	}
	ngOnInit() {}
	ngOnChanges(changes) {
		//console.log("OptionData changes ",changes);
	}
	public clicked(event, option: any) {
		//  event.stopPropagation();
		// console.log("option.selected ",option.selected);
		if (option.disabled) {
			return;
		}
		if (!option.selected) {
			option.backgroundColor = option.selectedBackgroundColor;
			option.selected = true;
			//console.log("option.selected if condition",option.selected);
		} else {
			option.selected = false;
			option.backgroundColor = "";
		}
		this.OptionSelected.emit({ item: option });
	}
}
